module.exports = __webpack_public_path__ + "img/add_localsotrm_img.af7f1345.svg";